import Row from './row';
import Col from './col';
export { Row, Col };


//////////////////
// WEBPACK FOOTER
// ../~/antd/es/grid/index.js
// module id = 140
// module chunks = 0